import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { useCallback } from "react";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";

import CascateList from "../../../../../../common/components/cascate_list";

/**
 * Header
 */

type Props = {
  funcionarios: FuncionarioDropDown[],
  funcionario: number,
  status: number,
  onFuncionarioChange: (funcionario: number) => void,
  onStatusChange: (status: number) => void,
};

export const Header = ({
  funcionarios,
  funcionario,
  status,
  onFuncionarioChange,
  onStatusChange,
}: Props) => {
  const handleFuncionarioChange = useCallback((newFuncionario: FuncionarioDropDown | null) => {
    onFuncionarioChange(newFuncionario?.idFuncionario ?? 0);
  }, [onFuncionarioChange]);

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value);
  }, [onStatusChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
            <div className="flex flex-col col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <DefaultAutocomplete
                options={funcionarios}
                getOptionLabel={x => x.nome}
                getOptionKey={x => x.idFuncionario}
                label="Funcionário"
                value={funcionarios.find(x => x.idFuncionario === funcionario)}
                onChange={handleFuncionarioChange}
                onNew={() => { }} />
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-1 gap-1">
              <FormControl size="small" fullWidth>
                <InputLabel id="modulo-dashboard"></InputLabel>
                <Select
                  labelId="modulo-dashboard"
                  label=""
                  value={status}
                  onChange={handleStatusChange}>
                  <MenuItem value={1}>Todas</MenuItem>
                  <MenuItem value={2}>Ativas</MenuItem>
                  <MenuItem value={3}>Inativas</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}